// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { Drug } from '../_models/drug.model';
// Models
import { QueryParamsModel } from '../../_base/crud';

export enum DrugActionTypes {
  AllDrugsRequested = '[Drugs] All Drugs Requested',
  AllDrugsLoaded = '[Drugs] All Drugs Loaded',
  DrugOnServerCreated = '[Drugs] Drug On Server Created',
  DrugCreated = '[Drugs] Drug Created',
  DrugOnServerUpdated = '[Drugs] Drug On Server Updated',
  DrugUpdated = '[Drugs] Drug Updated',
  DrugOnServerDeleted = '[Drugs] Drug On Server Deleted',
  DrugDeleted = '[Drugs] Drug Deleted',
  DrugsPageRequested = '[Drugs] Drugs Page Requested',
  DrugsPageLoaded = '[Drugs] Drugs Page Loaded',
  DrugsPageCancelled = '[Drugs] Drugs Page Cancelled',
  DrugsPageToggleLoading = '[Drugs] Drugs Page Toggle Loading',
  DrugsActionToggleLoading = '[Drugs] Drugs Action Toggle Loading',
  ThrowDrugError = '[Drugs] Throw Error',
  FireDrugSuccess = '[Drugs] Fire Success',
}

export class DrugOnServerCreated implements Action {
  readonly type = DrugActionTypes.DrugOnServerCreated;
  constructor(public payload: { drug: Drug }) {}
}

export class DrugCreated implements Action {
  readonly type = DrugActionTypes.DrugCreated;
  constructor(public payload: { drug: Drug }) {}
}

export class ThrowDrugError implements Action {
  readonly type = DrugActionTypes.ThrowDrugError;
  constructor(public payload: { error: any }) {}
}

export class FireDrugSuccess implements Action {
  readonly type = DrugActionTypes.FireDrugSuccess;
  constructor(public payload: { action_type: string }) {}
}

export class DrugOnServerUpdated implements Action {
  readonly type = DrugActionTypes.DrugOnServerUpdated;
  constructor(
    public payload: {
      partialDrug: Update<Drug>;
      drug: Drug;
    },
  ) {}
}
export class DrugUpdated implements Action {
  readonly type = DrugActionTypes.DrugUpdated;
  constructor(
    public payload: {
      partialDrug: Update<Drug>;
      drug: Drug;
    },
  ) {}
}

export class DrugOnServerDeleted implements Action {
  readonly type = DrugActionTypes.DrugOnServerDeleted;
  constructor(public payload: { id: number }) {}
}

export class DrugDeleted implements Action {
  readonly type = DrugActionTypes.DrugDeleted;
  constructor(public payload: { id: number }) {}
}

export class DrugsPageRequested implements Action {
  readonly type = DrugActionTypes.DrugsPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class DrugsPageLoaded implements Action {
  readonly type = DrugActionTypes.DrugsPageLoaded;
  constructor(public payload: { drugs: Drug[]; totalCount: number; page: QueryParamsModel }) {}
}

export class DrugsPageCancelled implements Action {
  readonly type = DrugActionTypes.DrugsPageCancelled;
}

export class DrugsPageToggleLoading implements Action {
  readonly type = DrugActionTypes.DrugsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class DrugsActionToggleLoading implements Action {
  readonly type = DrugActionTypes.DrugsActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export type DrugActions =
  | DrugCreated
  | DrugUpdated
  | DrugDeleted
  | DrugOnServerCreated
  | DrugOnServerUpdated
  | DrugOnServerDeleted
  | DrugsPageLoaded
  | DrugsPageCancelled
  | DrugsPageToggleLoading
  | DrugsPageRequested
  | ThrowDrugError
  | FireDrugSuccess
  | DrugsActionToggleLoading;
